// LOAD ALL THE READ ONLY DATA
import { toast } from "react-toastify";
import { API_INCIDENCIAS_STEPS } from "../views/MainLayout/components/shared/services/incidenciasSteps";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

const initialSteps = []

export const stepsFullfilledReducer = (state = initialSteps, action) => {
    switch(action.type){
        case "steps/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchSteps = () => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_INCIDENCIAS_STEPS.getIncidenciaSteps()
        const data = await response.data;
        dispatch({ type: 'steps/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}